var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:[ 'icon' , _vm.open ? 'open' : 'close'],attrs:{"width":"9","height":"10","viewBox":"0 0 9 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.03229 4.99989L0.560633 9.37874L0.504274 0.718667L8.03229 4.99989Z","fill":"#66615b","fill-opacity":_vm.open ? 0.95 : 0.6}})])
}
var staticRenderFns = []

export { render, staticRenderFns }